import { getTenantDir } from "@/plugins/env"

export const getImgUrl = url => {
  const dir = getTenantDir()
  return require(`~/assets/images/${dir}/${url}`)
}

const getIconClass = icon => {
  const dir = getTenantDir()
  return `${dir}-${icon}`
}

export default function ({ app }, inject) {
  inject("webHelper", {
    getImgUrl,
    getIconClass
  })
}
